package com.iptvplayer.shared.db

import kotlin.String

public data class IptvSourceEntity(
  public val id: String,
  public val name: String,
  public val type: String,
  public val url: String?,
  public val serverUrl: String?,
  public val username: String?,
  public val password: String?,
)
